import { render, staticRenderFns } from "./MapPositionNowPointsList.vue?vue&type=template&id=6635b661&scoped=true"
import script from "./MapPositionNowPointsList.vue?vue&type=script&lang=js"
export * from "./MapPositionNowPointsList.vue?vue&type=script&lang=js"
import style0 from "./MapPositionNowPointsList.vue?vue&type=style&index=0&id=6635b661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6635b661",
  null
  
)

export default component.exports